// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Loader = require("../../uikit/reason/atoms/Loader/Loader.bs.js");
let ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let ReadMoreButton = require("../../components/buttons/ReadMoreButton.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let MyDraftsWidgetDraftListItem = require("./MyDraftsWidgetDraftListItem.bs.js");
let MyDraftsWidgetDraftList_query_graphql = require("../../__generated__/MyDraftsWidgetDraftList_query_graphql.bs.js");
let MyDraftsWidgetDraftListPaginationQuery_graphql = require("../../__generated__/MyDraftsWidgetDraftListPaginationQuery_graphql.bs.js");

let getConnectionNodes = MyDraftsWidgetDraftList_query_graphql.Utils.getConnectionNodes;

let convertFragment = MyDraftsWidgetDraftList_query_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MyDraftsWidgetDraftList_query_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(MyDraftsWidgetDraftList_query_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, MyDraftsWidgetDraftList_query_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(MyDraftsWidgetDraftList_query_graphql.node, convertFragment, fRef);
}

let makeRefetchVariables = MyDraftsWidgetDraftListPaginationQuery_graphql.Types.makeRefetchVariables;

let convertRefetchVariables = MyDraftsWidgetDraftListPaginationQuery_graphql.Internal.convertVariables;

function useRefetchable(fRef) {
  return RescriptRelay_Fragment.useRefetchableFragment(MyDraftsWidgetDraftList_query_graphql.node, convertFragment, convertRefetchVariables, fRef);
}

function usePagination(fRef) {
  return RescriptRelay_Fragment.usePaginationFragment(MyDraftsWidgetDraftList_query_graphql.node, fRef, convertFragment, convertRefetchVariables);
}

let QueryFragment = {
  getConnectionNodes: getConnectionNodes,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment,
  makeRefetchVariables: makeRefetchVariables,
  convertRefetchVariables: convertRefetchVariables,
  useRefetchable: useRefetchable,
  usePagination: usePagination
};

function MyDraftsWidgetDraftList$MyDraftsEmpty(props) {
  return JsxRuntime.jsxs("div", {
    children: [
      "You have no draft posts available.",
      JsxRuntime.jsx("br", {}),
      JsxRuntime.jsx("br", {}),
      "Want to pre-market a listing on TAN? ",
      JsxRuntime.jsx(ButtonsV5.Link.make, {
        href: "/properties/new",
        className: "hover:underline",
        children: "Broadcast a property now"
      })
    ]
  });
}

let MyDraftsEmpty = {
  make: MyDraftsWidgetDraftList$MyDraftsEmpty
};

function MyDraftsWidgetDraftList(props) {
  let match = usePagination(props.query);
  let isLoadingNext = match.isLoadingNext;
  let hasNext = match.hasNext;
  let loadNext = match.loadNext;
  let data = match.data;
  let items = getConnectionNodes(data.draftsForCurrentAccountV6);
  let tmp;
  tmp = props.viewMoreMode === "ShowAllButton" ? (
      hasNext ? JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(ReadMoreButton.make, {
            href: "/my_drafts",
            children: "View All"
          }),
          className: "mt-4"
        }) : null
    ) : (
      hasNext ? JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
            onClick: param => {
              loadNext(30, undefined);
            },
            disabled: isLoadingNext,
            className: "w-full",
            children: "See More Drafts"
          }),
          className: "mt-4"
        }) : null
    );
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      items.length !== 0 ? JsxRuntime.jsx("div", {
          children: items.map(item => {
            let key = Stdlib_Option.getOr(item.nodeId, item.__typename);
            let match = data.draftsForCurrentAccountV6;
            return JsxRuntime.jsx(MyDraftsWidgetDraftListItem.make, {
              draft: item.fragmentRefs,
              listConnectionId: match !== undefined ? Primitive_option.some(match.__id) : undefined
            }, key);
          }),
          className: "flex flex-col border-b mb-6"
        }) : JsxRuntime.jsx(MyDraftsWidgetDraftList$MyDraftsEmpty, {}),
      tmp,
      isLoadingNext ? JsxRuntime.jsx(Loader.make, {}) : null
    ]
  });
}

let make = MyDraftsWidgetDraftList;

exports.QueryFragment = QueryFragment;
exports.MyDraftsEmpty = MyDraftsEmpty;
exports.make = make;
/* Loader Not a pure module */
